import React from "react";
import { useNode } from "@craftjs/core";
import { Paper, FormControl, FormLabel, Slider, Select, MenuItem } from "@material-ui/core";

export const Container = ({
                              background,
                              padding,
                              margin,
                              borderRadius,
                              elevation,
                              display,
                              justifyContent,
                              alignItems,
                              children
                          }) => {
    const { connectors: { connect, drag }, selected, dragging } = useNode(
        (node) => ({
            selected: node.events.selected,
            dragging: node.events.dragged
        })
    );

    return (
        <div
            ref={connect}
            style={{
                margin: `${margin}px`,
                position: 'relative',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                overflow: 'hidden'  // 防止内容溢出
            }}
            data-cy="container"
        >
            <div
                ref={drag}
                style={{
                    cursor: 'move',
                    width: '100%',
                    height: '100%',
                }}
            >
                <Paper
                    style={{
                        background,
                        padding: `${padding}px`,
                        borderRadius: `${borderRadius}px`,
                        display,
                        justifyContent,
                        alignItems,
                        minHeight: '30px',
                        border: selected ? '2px solid #2196f3' : '2px solid transparent',
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        overflowX: 'hidden'  // 防止水平滚动
                    }}
                    elevation={elevation}
                >
                    {children}
                    {!children && (
                        <div style={{
                            width: '100%',
                            height: '100%',
                            minHeight: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#999',
                            fontSize: '14px'
                        }}>
                            Drop components here
                        </div>
                    )}
                </Paper>
            </div>

            {/* Settings panel remains the same */}
            {selected && (
                <div style={{
                    padding: '10px',
                    marginTop: '10px',
                    background: '#f8f9fa',
                    borderRadius: '4px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
                }}>
                    {/* ... 设置面板内容保持不变 ... */}
                </div>
            )}
        </div>
    );
};

Container.craft = {
    props: {
        background: '#ffffff',
        padding: 20,
        margin: 0,  // 修改默认 margin 为 0
        borderRadius: 4,
        elevation: 0,
        display: "block",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    }
};